import styled from "@emotion/styled";

import { BaseLink } from "shared/components/common/base-link";
import { fontAngkor, fontFredoka, theme } from "shared/lib/styles";

import { BaseImage } from "scmp-app/components/common/base-image";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 20px;
  justify-content: flex-start;

  background-color: #f8ffac;

  ${theme.breakpoints.up("desktop")} {
    flex-wrap: wrap;

    inline-size: 295px;
    min-block-size: 326px;
  }
`;

export const StyledBaseLink = styled(BaseLink)``;

export const IconContainer = styled.div`
  position: absolute;

  display: flex;
  justify-content: center;
  align-items: center;

  inline-size: 100%;
  block-size: 100%;
`;

export const ImageContainer = styled.div`
  position: relative;

  display: flex;
`;

export const StyledBaseImage = styled(BaseImage)`
  inline-size: 100%;

  object-fit: cover;

  aspect-ratio: 295 / 184;
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 8px;

  padding-block: 16px 20px;
  padding-inline: 20px;

  ${theme.breakpoints.up("desktop")} {
    padding-block: 20px;
    padding-inline: 16px;
  }
`;

export const Label = styled.div`
  color: #ff7c1d;
  font-weight: 600;
  font-size: 16px;
  font-family: ${fontFredoka};
  line-height: 22px;
  letter-spacing: 0.8px;
  text-transform: uppercase;
`;

export const Title = styled.div`
  color: #333333;
  font-weight: 400;
  font-size: 20px;
  font-family: ${fontAngkor};
  line-height: 24px;
  letter-spacing: -0.4px;
`;
